import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import PrimaryButton from "../../jsx/components/button/primaryButton";
import outerPhoto from "../../icons/photos/loginPagePhoto.png";
import proIcon from "../../media/images/pro-icon.png";
import custIcon from "../../media/images/customer-icon.png";
import JoinAsField from "../../jsx/components/fields/joinAsField";
import InputField from "../../jsx/components/fields/inputField";
import "./auth.scss";
import PhonenumberField from "../../jsx/components/fields/phoneFields";
import { waitingUserJoin } from "../../service/api/user/waitingUserJoin";
import { authenticate } from "../../feature/authSlice";
import { setIsSignUpFlagTrue, setUserDetails } from "../../feature/userData/userData";
import {
  emailValidation,
  firstNameValidation,
  minLengthValidation,
  noSpaceOnChange,
  phoneOnChange,
  phoneValidation,
} from "../../validations/validation";
import ResponceToaster from "../../jsx/components/responceToaster/responceToaster";

import {
  btnAlreadyAUser,
  btnCustomer,
  btnGetStarted,
  btnLogin,
  btnProfessional,
  btnRegister,
  btnSignUp,
  btnTermsConditions,
  hintEnterValidationCode,
  lblEmail,
  lblFirstName,
  lblLastName,
  lblOr,
  lblPassword,
  lblSignUpTitle,
  passwordLengthText,
  txtAccountInfo,
  txtAccountInfoSubHeading,
  txtANewWay,
  txtCreateAccount,
  txtMobileNumber,
  txtRegisterAs,
  txtRoleCustomerSubTitle,
  txtRoleCustomerTitle,
  txtRoleProSubTitle,
  txtRoleProTitle,
  txtSearchAddress,
  txtSignUpAs,
} from "../../dataBaseFile/label";
import { btnJoinWaiting } from "../../dataBaseFile/alert";
import {
  acceptTermsCondition,
  enterFirstName,
  errEmptyEmailOrPhone,
  errEmptyPassword,
  validEmailText,
  validEmail_OR_MobileNumberText,
  validFirstName,
  validMobileNumberText,
  validPassword,
} from "../../dataBaseFile/error";

import PasswordField from "../../jsx/components/fields/passwordField";
import {
  confirmPasswordValidation,
  passwordValidation,
} from "../../functions/validations";
import { signUp } from "../../service/api/user/signUp";
import PasswordChecker from "../../component/passwordChecker/passwordChecker";
import EmailPhoneCombine from "../../jsx/components/fields/emailPhoneField";
import Avatar from "../../jsx/components/fields/avatar";
import filter from "../../icons/photos/filter.svg";
import { searchAddress } from "../../service/api/user/searchAddress";
import { apiRegisterCompany } from "../../service/api/companies/registerCompany";
import Select from "react-select";
import { addressByPlaceId } from "../../service/api/user/addressByPlaceID";
import { getCat } from "../../service/api/object/getCat";
import logo from "../../icons/photos/chillLogo.png";
import { Button } from "react-bootstrap";
import SkipButton from "../../jsx/components/button/skipButton";
import VerifyComponent from "./verifyComponent";
import { accountExistenceCheckApi } from "../../service/api/user/checkAccountExistence";
import { preventDefault } from "@fullcalendar/react";
import { activateUser } from "../../service/api/user/activationCode";
import Login from "./login";
import { resendCode } from "../../service/api/user/resendActivationCode";
import { verifySecurityCodeApi } from "../../service/api/user/verifySecurityCode";
import forgotBackgroundImg from "../../media/images/authAssets/forgotBackgroundImg.jpg";
import registrationImg from "../../media/images/authAssets/registrationImg.png";
import customerImg from "../../media/images/authAssets/customerImg.png";
import proImg from "../../media/images/authAssets/proImg.png";
import proTeamImg from "../../media/images/authAssets/proTeamImg.png";
import { checkCredentials } from "../../service/api/user/login";
import outerMainBannerImg from "../../media/images/authAssets/outerMainBannerImg.png";
import googleIcon from "../../media/images/google_logo.png";
import facebookIcon from "../../media/images/facebook_logo.webp";
import appleIcon from "../../media/images/apple_logo.png";
import { LoginSocialApple, LoginSocialFacebook } from "reactjs-social-login";
import { registerUserViaThirdPartyApp } from "../../service/api/user/registerUserViaThirdPartyApp";
import { GoogleLogin, useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import FeedbackModal from "../../jsx/components/feedback/feedback";
import { encryptPassword } from "../../service/encryptPassword";

export default function SignUpCustomer(props) {
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState("");
  const [isFirstNameError, setIsFirstNameError] = useState(false);
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState(localStorage.getItem("emailCompanyInvite") ? localStorage.getItem("emailCompanyInvite") : "");
  const [isEmailError, setIsEmailError] = useState(false);
  const [phonenumber, setPhonenumber] = useState(localStorage.getItem("phoneNumberCompanyInvite") ? localStorage.getItem("phoneNumberCompanyInvite") : "");
  const [isPhoneError, setIsPhoneError] = useState(false);
  const [countryCode, setCountryCode] = useState(localStorage.getItem("phoneCodeCompanyInvite") ? localStorage.getItem("phoneCodeCompanyInvite") : 1);
  // const [role, setRole] = useState(localStorage.getItem("roleCompanyInvite") ? localStorage.getItem("roleCompanyInvite") : "");
  const [role, setRole] = useState(2);
  const [loaderActive, setLoaderActive] = useState(false);
  const [responceMsg, setResponceMsg] = useState("");
  const [isCheckedB, setIsCheckedB] = useState(true);
  const [toasterType, setToasterType] = useState();
  const [handleToaster, setHandleToaster] = useState(false);
  const dispatch = useDispatch();
  const [password, setPassword] = useState("");
  const [isPassword, setIsPassword] = useState(false);
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [isPasswordConfirm, setIsPasswordConfirm] = useState(false);

  const [alias, setAlias] = useState("");

  const [isFocused, setIsFocused] = useState(false);
  const [errorFirstNameMsg, setErrorFirstNameMsg] = useState("");
  const [errorEmailMsg, setErrorEmailMsg] = useState("");
  const [passwordErrorMsg, setPasswordErrorMsg] = useState("");

  const [isEmailPhoneVal, setIsEmailPhoneVal] = useState(false);
  const [emailPhoneValue, setEmailPhoneValue] = useState(localStorage.getItem("emailCompanyInvite") ? localStorage.getItem("emailCompanyInvite") : localStorage.getItem("phoneNumberCompanyInvite") ? localStorage.getItem("phoneNumberCompanyInvite") : "");
  const [codeValue, setCodeValue] = useState(localStorage.getItem("phoneCodeCompanyInvite") ? localStorage.getItem("phoneCodeCompanyInvite") : 1);
  const [isPhone, setIsPhone] = useState(false);
  const [loginErrorMsg, setLoginErrorMsg] = useState("");

  const [feedbackMessage, setFeedbackMessage] = useState("")
  const [feedbackModal, setFeedbackModal] = useState(false);

  const [termsAndConditions, setTermsAndConditions] = useState(false);
  const [termsAndConditionsErr, setTermsAndConditionsErr] = useState(false);

  const [messageOptInFlag, setMessageOptInFlag] = useState(false);

  const handleAlias = (e) => {
    setAlias(e.target.value);

  };


  const handlePassword = (e) => {
    setIsPassword(false);
    setPassword(e.target.value);

    handlePasswordConfirm(e);
  };
  const handleBlurPassword = () => {
    setIsFocused(false);
    if (!passwordValidation(password)) {
      setIsPassword(true);
      if (password === "") {
        setPasswordErrorMsg(errEmptyPassword);
      } else {
        setPasswordErrorMsg(passwordLengthText);
      }
    }
  };

  const handlePasswordConfirm = (e) => {
    setIsPasswordConfirm(false);
    setPasswordConfirm(e.target.value);
  };
  const handleBlurPasswordConfirm = () => {
    if (!confirmPasswordValidation(password, passwordConfirm)) {
      setIsPasswordConfirm(true);
    }
  };

  function getStarted() {
    if (phoneValidation(localStorage.getItem("emailPhoneVal"))) {

      setLoaderActive(true);


      let formData = new FormData();
      parseInt(countryCode) &&
        formData.append("phone_code_id_int", parseInt(countryCode) || 0);
      parseInt(phonenumber) &&
        formData.append("phone_number_int", parseInt(phonenumber));
      email && formData.append("email_chr", "");
      formData.append(
        "otp_chr",
        verificationCode
      );
      formData.append("first_name_chr", firstName);
      formData.append("last_name_chr", lastName);
      formData.append("role_id_int", parseInt(role));
      formData.append("password_chr", password);
      formData.append("create_account_flag", 1);
      localStorage.getItem("fcm_token") && formData.append("fcm_token_chr", localStorage.getItem("fcm_token"));
      formData.append("voip_token_chr", '');
      zipCode && formData.append("zip_code_int", zipCode);

      dispatch(
        // waitingUserJoin(
        // signUp
        activateUser(formData, (res) => {
          // openNotification('success', 'topRight', res.data.message)
          localStorage.setItem("receiverPlatform", phonenumber);
          localStorage.setItem(
            "receiverPlatformPhoneCode",
            countryCode
          );

          dispatch(setIsSignUpFlagTrue());

          setResponceMsg(res.data.message);
          setLoaderActive(false);
          setToasterType("success");
          setHandleToaster(true);

          setTimeout(() => {
            setHandleToaster(false);
            if (signUpSteps == 2) {
              setSignUpSteps(3)
            }
          }, 1000);

          if (res?.data?.login_flag) {
            handleAuthentication(res.data)
          }
          // if (signUpSteps == 3) {



          //   if (phoneValidation(localStorage.getItem("emailPhoneVal"))) {
          //     let details = {
          //       phone_code_id_int: parseInt(localStorage.getItem("countryCodeVal")) || 1,
          //       phone_number_int: parseInt(localStorage.getItem("emailPhoneVal")),
          //       email_chr: "",
          //       password: localStorage.getItem("password"),
          //       fcm_token_chr: localStorage.getItem("fcm_token"),
          //       role_id_int: localStorage.getItem("roleId") || 0,
          //     };
          //     dispatch(
          //       checkCredentials(
          //         details,
          //         (res) => handleAuthentication(res.data),
          //         (err) => {
          //           navigate("/login")


          //         }
          //       )
          //     );
          //   } else {

          //     let details = {
          //       phone_code_id_int: null,
          //       phone_number_int: null,
          //       email_chr: localStorage.getItem("emailPhoneVal"),
          //       password: localStorage.getItem("password"),
          //       fcm_token_chr: localStorage.getItem("fcm_token"),
          //       voip_token_chr: "",
          //       role_id_int: localStorage.getItem("roleId") || 0,
          //     };
          //     dispatch(
          //       checkCredentials(
          //         details,
          //         (res) => handleAuthentication(res.data),
          //         (err) => {
          //           navigate("/login")

          //         }
          //       )
          //     );
          //   }


          // }

        },
          (error) => {
            // console.log(error.data.message)
            // openNotification('failed', 'topRight', error.data.message)
            setResponceMsg(error.data.message);
            setToasterType("errror");
            setHandleToaster(true);

            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);
          }
        )
      );
    }

    else if (emailValidation(localStorage.getItem("emailPhoneVal"))) {
      setLoaderActive(true);


      let formData = new FormData();
      // parseInt(countryCode) && formData.append("phone_code_id_int",  0);
      // parseInt(phonenumber) && formData.append("phone_number_int", 0);
      email && formData.append("email_chr", email);
      formData.append(
        "otp_chr", verificationCode

      );
      formData.append("first_name_chr", firstName);
      formData.append("last_name_chr", lastName);
      formData.append("role_id_int", parseInt(role));
      formData.append("password_chr", password);
      formData.append("create_account_flag", 1);
      localStorage.getItem("fcm_token") && formData.append("fcm_token_chr", localStorage.getItem("fcm_token"));
      formData.append("voip_token_chr", '');
      zipCode && formData.append("zip_code_int", zipCode);

      dispatch(
        activateUser(
          formData,
          (res) => {
            localStorage.setItem("receiverPlatform", email);
            setLoaderActive(false);

            dispatch(setIsSignUpFlagTrue());

            setResponceMsg(res.data.message);
            setToasterType("success");

            setHandleToaster(true);
            setTimeout(() => {
              setHandleToaster(false);
              if (signUpSteps == 2) {
                setSignUpSteps(3)
              }
            }, 11000);

            if (res?.data?.login_flag) {
              handleAuthentication(res.data)
            }

            // if (signUpSteps == 3) {
            //   // alert("Hhh")

            //   if (phoneValidation(localStorage.getItem("emailPhoneVal"))) {
            //     let details = {
            //       phone_code_id_int: parseInt(localStorage.getItem("countryCodeVal")) || 1,
            //       phone_number_int: parseInt(localStorage.getItem("emailPhoneVal")),
            //       email_chr: "",
            //       password: localStorage.getItem("password"),
            //       fcm_token_chr: localStorage.getItem("fcm_token"),
            //       role_id_int: localStorage.getItem("roleId") || 0,
            //     };
            //     dispatch(
            //       checkCredentials(
            //         details,
            //         (res) => handleAuthentication(res.data),
            //         (err) => {

            //           navigate("/login")

            //         }
            //       )
            //     );
            //   } else {
            //     let details = {
            //       phone_code_id_int: null,
            //       phone_number_int: null,
            //       email_chr: localStorage.getItem("emailPhoneVal"),
            //       password: localStorage.getItem("password"),
            //       fcm_token_chr: localStorage.getItem("fcm_token"),
            //       voip_token_chr: "",
            //       role_id_int: localStorage.getItem("roleId") || 0,
            //     };
            //     dispatch(
            //       checkCredentials(
            //         details,
            //         (res) => handleAuthentication(res.data),
            //         (err) => {
            //           navigate("/login")

            //         }
            //       )
            //     );
            //   }

            // }
            if (signUpSteps == 2) {
              setSignUpSteps(3)
            }
          },
          (error) => {
            // console.log(error)

            setLoaderActive(false);
            // openNotification('failed', 'topRight', error.data.message)
            // setResponceMsg(error.data.message);
            setToasterType("error");
            setResponceMsg(error.data.message);
            setHandleToaster(true);
            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);
          }
        ))
    }

  }

  function handleLogin() {
    setLoaderActive(true);


  }

  const handleAuthentication = (data) => {
    setLoaderActive(false);
    dispatch(authenticate());
    dispatch(setUserDetails(data));

    localStorage.setItem("access_token", data.access_token);
    localStorage.setItem("refresh_token", data.refresh_token);
    localStorage.setItem("user_id", data.data.user_id_ids);
    localStorage.setItem("roleId", data.data.role_id_ids);
    localStorage.setItem(
      "fullName",
      data.data.first_name_chr + " " + data.data.last_name_chr
    );
    navigate("/dashboard", { replace: true });
  };

  const handleAuthenticationWithSocialAcc = (data) => {
    setLoaderActive(false);
    dispatch(authenticate());
    dispatch(setUserDetails(data));
    localStorage.setItem("access_token", data.access_token);
    localStorage.setItem("refresh_token", data.refresh_token);
    localStorage.setItem("user_id", data.user_id);
    localStorage.setItem("roleId", data.user_details.role_id_ids);
    localStorage.setItem(
      "fullName",
      data.user_details.first_name_chr + " " + data.user_details.last_name_chr
    );
    navigate("/dashboard", { replace: true });
  };


  function handleRole(e) {
    setRole(e.target.value);
    // console.log("role", e.target.value);
  }

  const handleFirstName = (e) => {
    setIsFirstNameError(false);
    setFirstName(e.target.value);
  };
  const handleLastName = (e) => {
    setLastName(e.target.value);
  };


  function handleFirstNameBlurCheck() {
    if (!firstNameValidation(firstName)) {
      setIsFirstNameError(true);
      if (firstName === "") {
        setErrorFirstNameMsg(enterFirstName);
      } else {
        setErrorFirstNameMsg(validFirstName);
      }
    }
  }

  useEffect(() => {
    const dot = ".";
    const leng = emailPhoneValue.length - 1;
    if (!isNaN(emailPhoneValue) && emailPhoneValue.charAt(leng) !== dot) {
      if (emailPhoneValue.length < 11) {
        setIsPhone(true);
      } else {
        setIsPhone(false);
      }
    } else {
      setIsPhone(false);
    }
    if (emailPhoneValue === "") {
      setIsPhone(false);
    }
  }, [emailPhoneValue]);







  // Business Registration starts here-------------------
  const [businessRegToggle, setBusinessRegToggle] = useState(false);
  const [addressLine1, setAddressLine1] = useState(" ");
  const [addressLine2, setAddressLine2] = useState(" ");
  const [cityName, setCityName] = useState("");
  const [stateName, setStateName] = useState("");
  const [countryName, setCountryName] = useState(" ");
  const [zipCode, setZipCode] = useState("");
  const [latVal, setLatVal] = useState(0);
  const [longVal, setLongVal] = useState(0);
  const [address, setAddress] = useState("");
  const [placeIdVal, setPlaceId] = useState("");
  const [addressArr, setAddressArr] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [isCompanytNameError, setIsCompanyNameError] = useState(false);
  const [companyName, setComapanyName] = useState("");
  const [isCompanytEmailError, setIsCompanyEmailError] = useState(false);
  const [companyEmail, setComapanyEmail] = useState("");

  const [photoToUpload, setPhotoToUpload] = useState(null);
  const [companyAvatarUrl, setCompanyAvatarUrl] = useState("");
  const [isAddress, setIsAddress] = useState(false);

  const [resMessage, setResMessage] = useState("");

  const [catApiCall, setCatApiCall] = useState(false);

  const handleBusinessRegToggle = () => {
    setBusinessRegToggle(!businessRegToggle);
    clearStatesBusinessReg();
    setCatApiCall(true);
  };

  // function to clear states after the toggle of business registration
  const clearStatesBusinessReg = () => {
    setFirstName("");
    setIsFirstNameError(false);
    setLastName("");
    setComapanyName("");
    setIsCompanyNameError(false);
    setComapanyEmail("");
    setIsEmailError(false);
    setPhonenumber("");
    setIsPhoneError(false);

    setAddressLine1("");
    setAddressLine2(" ");
    setCityName("");
    setStateName("");
    setCountryName(" ");
    setZipCode("");
    setLatVal(0);
    setLongVal(0);
    setAddress("");
    setPlaceId("");
    setAddressArr([]);
    setSearchText("");

    setPhotoToUpload(null);
    setCompanyAvatarUrl("");
    setIsAddress(false);
    setRole("");
  };

  useEffect(() => {
    const timeOutId = setTimeout(searchCalling, 1000);
    return () => clearTimeout(timeOutId);
  }, [searchText]);

  function searchCalling() {
    if (searchText.trim().length > 2) {
      let details = {
        address_chr: searchText.trim(),
      };
      dispatch(
        searchAddress(details, (res) => {
          setAddressArr(res.data.data);
        })
      );
    }
  }






  // Add expertise functions

  const [selectedOptions, setSelectedOptions] = useState([]);
  const [expertiseArray, setExpertiseArray] = useState([]);
  const [pageSizeCat, setPageSizeCat] = useState(25);
  const [pageCat, setPageCat] = useState(1);
  const [catOrder, setCatOrder] = useState("ASC");
  const [catArr, setCatArr] = useState([]);
  const [catId, setCatId] = useState();
  const [prodTypeArr, setProdTypeArr] = useState([]);

  useEffect(() => {
    if (catApiCall) {
      var forCatData = {
        page_index: pageCat,
        page_size: pageSizeCat,
        sorting_order: catOrder,
      };

      dispatch(
        getCat(forCatData, (res) => {
          setCatArr(res.data.data);
        })
      );
    }
  }, [catApiCall]);





  useEffect(() => {
    setExpertiseArray(selectedOptions.map((option) => option.value));
  }, [selectedOptions]);
  // Business Registration ends here------------------

  const [signUpSteps, setSignUpSteps] = useState(parseInt(localStorage.getItem("screen_number")));
  const [accountType, setAccountType] = useState("phone");
  const [isRoleSelected, setIsRoleSelected] = useState(false);

  // console.log("Email", email);
  // console.log("Phonenumber", phonenumber);
  // console.log("countryCode", countryCode);

  // useEffect(() => {
  //   // If email then optional will phone and vice versa
  //   if (localStorage.getItem("emailPhoneVal")) {
  //     if (emailValidation(localStorage.getItem("emailPhoneVal"))) {
  //       setAccountType("phone");
  //       setEmail(localStorage.getItem("emailPhoneVal"));
  //     }

  //     if (phoneValidation(localStorage.getItem("emailPhoneVal"))) {
  //       setAccountType("email");
  //       setPhonenumber(localStorage.getItem("emailPhoneVal"));
  //       setCountryCode(localStorage.getItem("countryCodeVal"));
  //     }
  //   }


  // }, [localStorage.getItem("emailPhoneVal")]);

  const handleCheckStepFirstName = (e) => {
    e?.preventDefault();
    if (!firstNameValidation(firstName)) {
      setIsFirstNameError(true);

      if (firstName === "") {
        setErrorFirstNameMsg(enterFirstName);
      } else {
        setErrorFirstNameMsg(validFirstName);
      }
    } else {
      getStarted();
    }
  };

  const checkIfEmailOrPhoneExists = () => {
    if (accountType === "email") {
      if (emailValidation(email)) {
        setLoaderActive(true);
        let details = new FormData();
        details.append("phone_code_id_int", 0);
        details.append("phone_number_int", 0);
        details.append("email_chr", email);
        details.append("create_account_flag", 0);
        dispatch(
          accountExistenceCheckApi(
            details,
            (res) => {
              setLoaderActive(false);
              if (res.data.account_exists) {
                setResponceMsg("Email already exists");
                setToasterType("error");
                setHandleToaster(true);
                setTimeout(() => {
                  setHandleToaster(false);
                }, 11000);
              }
              if (!res.data.account_exists) {
                setSignUpSteps(3);
              }
            },
            (err) => {
              setLoaderActive(false);
              setResponceMsg(err.data.message);
              setToasterType("error");
              setHandleToaster(true);
              setTimeout(() => {
                setHandleToaster(false);
              }, 11000);
            }
          )
        );
      }
    }

    if (accountType === "phone") {
      if (phoneValidation(phonenumber)) {
        setLoaderActive(true);
        let details = new FormData();
        details.append("phone_code_id_int", parseInt(countryCode) || 1);
        details.append("phone_number_int", parseInt(phonenumber));
        details.append("email_chr", "");
        details.append("create_account_flag", 0);
        dispatch(
          accountExistenceCheckApi(
            details,
            (res) => {
              setLoaderActive(false);
              if (res.data.account_exists) {
                setResponceMsg("Phone number already exists");
                setToasterType("error");
                setHandleToaster(true);
                setTimeout(() => {
                  setHandleToaster(false);
                }, 11000);
              }
              if (!res.data.account_exists) {
                setSignUpSteps(3);
              }
            },
            (err) => {
              setLoaderActive(false);
              setResponceMsg(err.data.message);
              setToasterType("success");
              setHandleToaster(true);
              setTimeout(() => {
                setHandleToaster(false);
              }, 11000);
            }
          )
        );
      }
    }
  };



  const handleCheckStepRoleSelected = () => {
    if (isRoleSelected) {
      // setSignUpSteps(3)
      getStarted()
    } else {

    }
  };



  const handleBackSignup = () => {

    if (signUpSteps == 1) {
      navigate("/login");
      setResendCodeTimer(60);
    } else if (signUpSteps == 2) {
      navigate("/login")
    } else if (signUpSteps == 0) {
      navigate("/login")
    }
    else {
      setSignUpSteps(signUpSteps - 1);
    }
  };



  const [verificationCode, setVerificationCode] = useState("")
  const [verificationCodeError, setVerificationCodeError] = useState(false)
  function handleVerificationBlurCheck() {
    if (verificationCode.length < 6) {
      setVerificationCodeError(true)
    } else {
      setVerificationCodeError(false)
    }
  }
  function handleVerificationCode(e) {
    setVerificationCodeError(false)
    setVerificationCode(e.target.value)
  }
  const [resendCodeTimer, setResendCodeTimer] = useState(60);
  const [resendCodeCheck, setResendCodeCheck] = useState(true);

  const intervalId = useRef(null);
  useEffect(() => {

    if (resendCodeCheck && resendCodeTimer > 0) {
      intervalId.current = setInterval(
        () => setResendCodeTimer((prev) => prev - 1),
        1000
      );
    } else if (!resendCodeCheck || resendCodeTimer === 0) {
      clearInterval(intervalId.current);
    }

    if (resendCodeTimer === 0) {
      setResendCodeCheck(false);
    }
    return () => clearInterval(intervalId.current);
  }, [resendCodeCheck, resendCodeTimer]);

  const resendCodeActivation = () => {
    if (phoneValidation(localStorage.getItem("emailPhoneVal"))) {
      let formData = new FormData();
      formData.append(
        "phone_code_id_int",
        parseInt(localStorage.getItem("countryCodeVal"))
      );
      formData.append(
        "phone_number_int",
        parseInt(localStorage.getItem("emailPhoneVal"))
      );
      formData.append("email_chr", "");

      dispatch(
        resendCode(
          formData,
          (res) => {
            setResponceMsg(res.data.message);
            setToasterType("success");
            setHandleToaster(true);

            setResendCodeCheck(true);
            setResendCodeTimer(60);

            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);
          },
          (err) => {
            setResponceMsg(err.data.message);
            setToasterType("error");
            setHandleToaster(true);

            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);
          }
        )
      );
    } else if (emailValidation(localStorage.getItem("emailPhoneVal"))) {
      let formData = new FormData();
      formData.append("phone_code_id_int", 0);
      formData.append("phone_number_int", 0);
      formData.append("email_chr", localStorage.getItem("emailPhoneVal"));

      dispatch(
        resendCode(
          formData,
          (res) => {
            setResponceMsg(res.data.message);
            setToasterType("success");
            setHandleToaster(true);

            setResendCodeCheck(true);
            setResendCodeTimer(60);

            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);
          },
          (err) => {
            setResponceMsg(err.data.message);
            setToasterType("error");
            setHandleToaster(true);

            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);
          }
        )
      );
    }
  };

  function checkAndVerifyCode(e) {
    e.preventDefault();
    setLoaderActive(true);
    if (phoneValidation(localStorage.getItem("emailPhoneVal"))) {
      let formData = new FormData();
      formData.append(
        "phone_code_id_int",
        parseInt(localStorage.getItem("countryCodeVal"))
      );
      formData.append(
        "phone_number_int",
        parseInt(localStorage.getItem("emailPhoneVal"))
      );
      formData.append("email_chr", "");
      formData.append("security_code_chr", verificationCode);

      dispatch(
        verifySecurityCodeApi(
          formData,
          (res) => {

            localStorage.setItem("security_code_chr", verificationCode)
            setSignUpSteps(res.data.screen_number);
            setLoaderActive(false);
            setRole(res?.data?.user_data?.user_roles[0]?.role_id_ids)
            res?.data?.user_data?.first_name_chr && setFirstName(res?.data?.user_data?.first_name_chr);
            res?.data?.user_data?.last_name_chr && setLastName(res?.data?.user_data?.last_name_chr);
          },
          (err) => {
            setLoaderActive(false);
            setVerificationCodeError(true);
          }
        )
      );
    } else if (emailValidation(localStorage.getItem("emailPhoneVal"))) {
      let formData = new FormData();
      formData.append("phone_code_id_int", 0);
      formData.append("phone_number_int", 0);
      formData.append("email_chr", localStorage.getItem("emailPhoneVal"));
      formData.append("security_code_chr", verificationCode);

      dispatch(
        verifySecurityCodeApi(
          formData,
          (res) => {

            localStorage.setItem("security_code_chr", verificationCode)
            setSignUpSteps(res.data.screen_number)
            setLoaderActive(false);
            setRole(res?.data?.user_data?.user_roles[0]?.role_id_ids);
            res?.data?.user_data?.first_name_chr && setFirstName(res?.data?.user_data?.first_name_chr);
            res?.data?.user_data?.last_name_chr && setLastName(res?.data?.user_data?.last_name_chr);
          },
          (err) => {
            setLoaderActive(false);
            setVerificationCodeError(true);
          }
        )
      );
    } else {
      setLoaderActive(false)
    }
  }

  // useEffect(() => {
  //   if (role) {
  //     setIsRoleSelected(true);
  //   }
  // }, [role])

  const handleZipCode = (e) => {
    setZipCode(e.target.value.replace(/\D/g, ''))
  }


  // new signup functions

  const [toggleForSignUpPage, setToggleForSignUpPage] = useState(true)
  const handleRoleSelected = () => {
    if (!role) {
      setIsRoleSelected(true)
      setToggleForSignUpPage(false)
    } else {
      setIsRoleSelected(false)
      setToggleForSignUpPage(true)
    }
  }

  useEffect(() => {
    if (localStorage.getItem("roleCompanyInvite")) {
      setToggleForSignUpPage(true)
    }
  }, [localStorage.getItem("roleCompanyInvite")])

  const handleEmail = (e) => {
    setIsEmailError(false)
    setIsPhoneError(false)
    noSpaceOnChange(e.target.value) && setEmail(e.target.value)
  }

  function handleEmailBlurCheck() {
    if (!emailValidation(email)) {
      setIsEmailError(true)
    }
  }

  const handlePhonenumber = (e) => {
    setIsPhoneError(false)
    setIsEmailError(false)
    phoneOnChange(e.target.value) && setPhonenumber(e.target.value)
  }

  const handleCountryCode = (e, v) => {
    // setCountryCode(v.country_id_ids)
    setCountryCode(e)
  }

  const handleClearCompanyInvite = () => {

    localStorage.getItem("companyIdInvite") && localStorage.removeItem("companyIdInvite")
    localStorage.getItem("companyInvitationIdInvite") && localStorage.removeItem("companyInvitationIdInvite")
    localStorage.getItem("emailCompanyInvite") && localStorage.removeItem("emailCompanyInvite")
    localStorage.getItem("phoneCodeCompanyInvite") && localStorage.removeItem("phoneCodeCompanyInvite")
    localStorage.getItem("phoneNumberCompanyInvite") && localStorage.removeItem("phoneNumberCompanyInvite")
    localStorage.getItem("roleCompanyInvite") && localStorage.removeItem("roleCompanyInvite")
    localStorage.getItem("ticket_id") && localStorage.removeItem("ticket_id")
  }

  const handleSignUpOld = async (e) => {
    e?.preventDefault();
    const encryptedPassword = await encryptPassword(password);
    const encryptedPasswordConfirm = await encryptPassword(passwordConfirm);

    if (firstNameValidation(firstName)) {
      if (passwordValidation(password)) {
        if (confirmPasswordValidation(password, passwordConfirm)) {
          if (phonenumber.length > 0 && email.length === 0) {
            // case 1

            if (phoneValidation(phonenumber)) {
              setLoaderActive(true)

              let details = {
                first_name_chr: firstName,
                last_name_chr: lastName,
                alias_name_chr: alias,
                role_id_list: [parseInt(role)],
                phone_code_id_int: parseInt(countryCode) || 1,
                phone_number_int: parseInt(phonenumber) || 0,
                email_chr: email,
                password: process.env.REACT_APP_BASE_URL?.includes('dev') ? encryptedPassword : password,
                confirm_password: process.env.REACT_APP_BASE_URL?.includes('dev') ? encryptedPasswordConfirm : passwordConfirm,
                creator_user_id_ids: "",
                creator_role_id_ids: "",
                referal_code_chr: localStorage.getItem("referalCode") ? localStorage.getItem("referalCode") : "",
                zip_code_int: parseInt(zipCode),
                company_id_ids: localStorage.getItem("companyIdInvite") ? localStorage.getItem("companyIdInvite") : "",
                // company_onboarding_flag: localStorage.getItem("companyIdInvite") ? 1 : 0,
                company_onboarding_flag: 0,
                service_request_id_ids: localStorage.getItem("ticket_id") || '',
                message_opt_in_flag: messageOptInFlag ? 1 : 0,
              }

              dispatch(signUp(details, (res) => {
                setToasterType("success")
                setResponceMsg(res.data.message);
                setHandleToaster(true);


                localStorage.setItem("countryCodeVal", countryCode);
                localStorage.setItem("emailPhoneVal", phonenumber);

                handleClearCompanyInvite();

                localStorage.getItem("referalCode") && localStorage.removeItem("referalCode");

                setTimeout(() => {
                  setHandleToaster(false);
                }, 11000);

                setTimeout(() => {
                  setLoaderActive(false);
                  navigate("/activateUsers");
                }, 2000);

              }, (res) => {
                setToasterType("error")
                setResponceMsg(res.data.message);
                setHandleToaster(true);
                setTimeout(() => {
                  setHandleToaster(false);
                }, 11000);
                setLoaderActive(false)
              }))
            } else {
              setIsPhoneError(true)
            }
          }

          if (email.length > 0 && phonenumber.length === 0) {
            //case 2


            if (emailValidation(email)) {
              setLoaderActive(true)
              let details = {
                first_name_chr: firstName,
                last_name_chr: lastName,
                alias_name_chr: alias,
                role_id_list: [parseInt(role)],
                phone_code_id_int: parseInt(countryCode) || 1,
                phone_number_int: parseInt(phonenumber) || 0,
                email_chr: email,
                password: process.env.REACT_APP_BASE_URL?.includes('dev') ? encryptedPassword : password,
                confirm_password: process.env.REACT_APP_BASE_URL?.includes('dev') ? encryptedPasswordConfirm : passwordConfirm,
                creator_user_id_ids: "",
                creator_role_id_ids: "",
                referal_code_chr: localStorage.getItem("referalCode") ? localStorage.getItem("referalCode") : "",
                zip_code_int: parseInt(zipCode),
                company_id_ids: localStorage.getItem("companyIdInvite") ? localStorage.getItem("companyIdInvite") : "",
                // company_onboarding_flag: localStorage.getItem("companyIdInvite") ? 1 : 0,
                company_onboarding_flag: 0,
                message_opt_in_flag: messageOptInFlag ? 1 : 0,
              }

              dispatch(signUp(details, (res) => {
                setToasterType("success")
                setResponceMsg(res.data.message);
                setHandleToaster(true);

                localStorage.setItem("emailPhoneVal", email);

                handleClearCompanyInvite();

                localStorage.getItem("referalCode") && localStorage.removeItem("referalCode");

                setTimeout(() => {
                  setHandleToaster(false);
                }, 11000);

                setTimeout(() => {
                  setLoaderActive(false);
                  navigate("/activateUsers");
                }, 2000);

              }, (res) => {
                setLoaderActive(false)

                setToasterType("error")
                setResponceMsg(res?.data?.message);
                setHandleToaster(true);
                setTimeout(() => {
                  setHandleToaster(false);
                }, 11000);
              }))
            } else {
              setIsEmailError(true)
            }
          }

          if (email.length > 0 && phonenumber.length > 0) {
            // case 3

            if (emailValidation(email) && phoneValidation(phonenumber)) {
              setLoaderActive(true)

              let details = {
                first_name_chr: firstName,
                last_name_chr: lastName,
                alias_name_chr: alias,
                role_id_list: [parseInt(role)],
                phone_code_id_int: parseInt(countryCode) || 1,
                phone_number_int: parseInt(phonenumber) || 0,
                email_chr: email,
                // password: password,
                // confirm_password: password,
                password: process.env.REACT_APP_BASE_URL?.includes('dev') ? encryptedPassword : password,
                confirm_password: process.env.REACT_APP_BASE_URL?.includes('dev') ? encryptedPasswordConfirm : passwordConfirm,
                creator_user_id_ids: "",
                creator_role_id_ids: "",
                referal_code_chr: localStorage.getItem("referalCode") ? localStorage.getItem("referalCode") : "",
                zip_code_int: parseInt(zipCode),
                company_id_ids: localStorage.getItem("companyIdInvite") ? localStorage.getItem("companyIdInvite") : "",
                // company_onboarding_flag: localStorage.getItem("companyIdInvite") ? 1 : 0,
                company_onboarding_flag: 0,
                message_opt_in_flag: messageOptInFlag ? 1 : 0,
              }

              dispatch(signUp(details, (res) => {
                setToasterType("success")
                setResponceMsg(res.data.message);
                setHandleToaster(true);

                localStorage.setItem("emailPhoneVal", email);

                handleClearCompanyInvite();

                localStorage.getItem("referalCode") && localStorage.removeItem("referalCode");

                setTimeout(() => {
                  setHandleToaster(false);
                }, 11000);

                setTimeout(() => {
                  setLoaderActive(false);
                  navigate("/activateUsers");
                }, 2000);

              }, (res) => {
                setToasterType("error")
                setResponceMsg(res.data.message);
                setHandleToaster(true);
                setTimeout(() => {
                  setHandleToaster(false);
                }, 11000);
                setLoaderActive(false)
              }))
            } else {
              if (!emailValidation(email)) {
                setIsEmailError(true)
              }
              if (!phoneValidation(phonenumber)) {
                setIsPhoneError(true)
              }
            }
          }

          if (email.length === 0 && phonenumber.length === 0) {
            setIsPhoneError(true)
            setIsEmailError(true)
          }
        } else {
          setIsPasswordConfirm(true);
        }
      } else {
        setIsPassword(true);
        if (password === "") {
          setPasswordErrorMsg(validPassword)
        } else {
          setPasswordErrorMsg(passwordLengthText)
        }
      }
    } else {
      if (!firstNameValidation(firstName)) {
        setIsFirstNameError(true)
        if (firstName === "") {
          setErrorFirstNameMsg(enterFirstName);
        } else {
          setErrorFirstNameMsg(validFirstName);
        }
      }
    }
  }

  const handleSignUp = async (e) => {
    e.preventDefault();

    const encryptedPassword = await encryptPassword(password);
    const encryptedPasswordConfirm = await encryptPassword(passwordConfirm);

    if (!firstNameValidation(firstName)) {
      setIsFirstNameError(true)
      if (firstName === "") {
        setErrorFirstNameMsg(enterFirstName);
      } else {
        setErrorFirstNameMsg(validFirstName);
      }
    }

    if (!isPhone) {
      if (!emailValidation(emailPhoneValue)) {
        setIsEmailPhoneVal(true);
        if (emailPhoneValue === "") {
          setIsEmailPhoneVal(true);
          setLoginErrorMsg(errEmptyEmailOrPhone);
        } else if (!phoneValidation(emailPhoneValue)) {
          setIsEmailPhoneVal(true);
          setLoginErrorMsg(validEmail_OR_MobileNumberText);
        }
      }
    } else {
      if (!phoneValidation(emailPhoneValue)) {
        setIsEmailPhoneVal(true);
        if (emailPhoneValue === "") {
          setIsEmailPhoneVal(true);
          setLoginErrorMsg(errEmptyEmailOrPhone);
        } else if (!emailValidation(emailPhoneValue)) {
          setIsEmailPhoneVal(true);
          setLoginErrorMsg(validEmail_OR_MobileNumberText);
        }
      }
    }

    if (!passwordValidation(password)) {
      setIsPassword(true);
      if (password === "") {
        setPasswordErrorMsg(validPassword)
      } else {
        setPasswordErrorMsg(passwordLengthText)
      }
    }

    if (!confirmPasswordValidation(password, passwordConfirm)) {
      setIsPasswordConfirm(true);
    }

    if (!termsAndConditions) {
      setTermsAndConditionsErr(true);
    }

    if (termsAndConditions && firstNameValidation(firstName) && (!isPhone ? emailValidation(emailPhoneValue) : phoneValidation(emailPhoneValue)) && passwordValidation(password) && confirmPasswordValidation(password, passwordConfirm)) {
      if (isPhone) {
        setLoaderActive(true)
        let details = {
          first_name_chr: firstName,
          last_name_chr: lastName,
          alias_name_chr: alias,
          role_id_list: [parseInt(role)],
          phone_code_id_int: parseInt(codeValue) || 1,
          phone_number_int: parseInt(emailPhoneValue) || 0,
          email_chr: '',
          // password: password,
          // confirm_password: passwordConfirm,
          password: process.env.REACT_APP_BASE_URL?.includes('dev') ? encryptedPassword : password,
          confirm_password: process.env.REACT_APP_BASE_URL?.includes('dev') ? encryptedPasswordConfirm : passwordConfirm,
          creator_user_id_ids: "",
          creator_role_id_ids: "",
          referal_code_chr: localStorage.getItem("referalCode") ? localStorage.getItem("referalCode") : "",
          zip_code_int: parseInt(zipCode),
          company_id_ids: localStorage.getItem("companyIdInvite") ? localStorage.getItem("companyIdInvite") : "",
          // company_onboarding_flag: localStorage.getItem("companyIdInvite") ? 1 : 0,
          company_onboarding_flag: 0,
          invitation_id: localStorage.getItem("companyInvitationIdInvite") ? localStorage.getItem("companyInvitationIdInvite") : "",
          service_request_id_ids: localStorage.getItem("ticket_id") || '',
          message_opt_in_flag: messageOptInFlag ? 1 : 0,
        }

        dispatch(signUp(details, (res) => {
          setToasterType("success")
          setResponceMsg(res.data.message);
          // setHandleToaster(true);


          localStorage.setItem("countryCodeVal", codeValue);
          localStorage.setItem("emailPhoneVal", emailPhoneValue);

          handleClearCompanyInvite();

          localStorage.getItem("referalCode") && localStorage.removeItem("referalCode");

          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);

          navigate("/activateUsers");

          // setTimeout(() => {
          //   setLoaderActive(false);
          //   navigate("/activateUsers");
          // }, 2000);

        }, (res) => {
          setToasterType("error")
          setResponceMsg(res.data.message);
          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);
          setLoaderActive(false)
        }))

      } else {
        setLoaderActive(true)
        let details = {
          first_name_chr: firstName,
          last_name_chr: lastName,
          alias_name_chr: alias,
          role_id_list: [parseInt(role)],
          phone_code_id_int: parseInt(codeValue) || 1,
          phone_number_int: parseInt(emailPhoneValue) || 0,
          email_chr: emailPhoneValue,
          // password: password,
          // confirm_password: passwordConfirm,
          password: process.env.REACT_APP_BASE_URL?.includes('dev') ? encryptedPassword : password,
          confirm_password: process.env.REACT_APP_BASE_URL?.includes('dev') ? encryptedPasswordConfirm : passwordConfirm,
          creator_user_id_ids: "",
          creator_role_id_ids: "",
          referal_code_chr: localStorage.getItem("referalCode") ? localStorage.getItem("referalCode") : "",
          zip_code_int: parseInt(zipCode),
          company_id_ids: localStorage.getItem("companyIdInvite") ? localStorage.getItem("companyIdInvite") : "",
          // company_onboarding_flag: localStorage.getItem("companyIdInvite") ? 1 : 0,
          company_onboarding_flag: 0,
          invitation_id: localStorage.getItem("companyInvitationIdInvite") ? localStorage.getItem("companyInvitationIdInvite") : "",
          service_request_id_ids: localStorage.getItem("ticket_id") || '',
          message_opt_in_flag: messageOptInFlag ? 1 : 0,
        }

        dispatch(signUp(details, (res) => {
          setToasterType("success")
          setResponceMsg(res.data.message);
          // setHandleToaster(true);

          localStorage.setItem("emailPhoneVal", emailPhoneValue);

          handleClearCompanyInvite();

          localStorage.getItem("referalCode") && localStorage.removeItem("referalCode");

          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);

          navigate("/activateUsers");

          // setTimeout(() => {
          //   setLoaderActive(false);
          //   navigate("/activateUsers");
          // }, 2000);

        }, (res) => {
          setLoaderActive(false)

          setToasterType("error")
          setResponceMsg(res?.data?.message);
          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);
        }))
      }
    }
  }

  function handlePhonenumberBlurCheck() {
    if (
      (!phoneValidation(phonenumber) || phonenumber.length !== 10) && phonenumber.length !== 0
    ) {
      setIsPhoneError(true);
    }
  }

  // Functions for the signup with social accounts
  const [signInLoader, setSignInLoader] = useState(false);
  const [googleData, setGoogleData] = useState({});
  const [appleData, setAppleData] = useState({});
  const [socialAccType, setSocialAccType] = useState("");
  const [facebookData, setFacebookData] = useState({});

  // Social Account Singin using the Google account
  const handleGoogleSignin = (credentialResponseDecoded) => {
    // We have modified the flow for the getting the custom button for login
    // const credentialResponseDecoded = jwtDecode(credentialResponse.credential)
    // console.log(credentialResponseDecoded?.given_name, credentialResponseDecoded?.family_name, credentialResponseDecoded?.email, credentialResponseDecoded?.sub, "Finally Success")
    setSignInLoader(true);
    setGoogleData(credentialResponseDecoded);
    setSocialAccType("google");

    let details = new FormData();
    credentialResponseDecoded?.given_name &&
      details.append("first_name_chr", credentialResponseDecoded?.given_name);
    credentialResponseDecoded?.family_name &&
      details.append("last_name_chr", credentialResponseDecoded?.family_name);
    credentialResponseDecoded?.email &&
      details.append("email_chr", credentialResponseDecoded?.email);
    details.append("fcm_token_chr", localStorage.getItem("fcm_token"));
    credentialResponseDecoded?.sub &&
      details.append("social_id_chr", credentialResponseDecoded?.sub);
    details.append("social_account_type_chr", "google");
    details.append("role_id_int", parseInt(role));
    localStorage.getItem("companyIdInvite") && details.append("company_id_ids", localStorage.getItem("companyIdInvite"));

    details.append("service_request_id_ids", localStorage.getItem("ticket_id") || '');

    localStorage.getItem("referalCode") && details.append("referal_code_chr", localStorage.getItem("referalCode"));
    details.append("message_opt_in_flag", messageOptInFlag ? 1 : 0);

    dispatch(
      registerUserViaThirdPartyApp(
        details,
        (res) => {
          setSignInLoader(false);
          handleAuthenticationWithSocialAcc(res.data);

          handleClearCompanyInvite();

          dispatch(setIsSignUpFlagTrue());

          localStorage.getItem("referalCode") && localStorage.removeItem("referalCode");

        },
        (err) => {
          if (err.data.is_flag_role == 0) {
            // handleShowRoleModal();
            alert("Please select role")
          }
          setSignInLoader(false);

          if (err.data.is_flag_role != 0) {
            setResponceMsg(err.data.message);
            setToasterType("error");

            setHandleToaster(true);
            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);
          }
        }
      )
    );
  };

  const handleSocialSigninForNewUser = () => {
    if (!isRoleSelected) {
      return;
    }

    setLoaderActive(true);
    setSignInLoader(true);

    let details = new FormData();
    if (socialAccType === "google") {
      googleData?.given_name &&
        details.append("first_name_chr", googleData?.given_name);
      googleData?.family_name &&
        details.append("last_name_chr", googleData?.family_name);
      googleData?.email && details.append("email_chr", googleData?.email);
      details.append("fcm_token_chr", localStorage.getItem("fcm_token"));
      googleData?.sub && details.append("social_id_chr", googleData?.sub);
      details.append("social_account_type_chr", "google");
      details.append("role_id_int", parseInt(role));

      details.append("service_request_id_ids", localStorage.getItem("ticket_id") || '');
      details.append("message_opt_in_flag", messageOptInFlag ? 1 : 0);
    }

    if (socialAccType === "facebook") {
      facebookData?.first_name &&
        details.append("first_name_chr", facebookData?.first_name);
      facebookData?.last_name &&
        details.append("last_name_chr", facebookData?.last_name);
      facebookData?.email && details.append("email_chr", facebookData?.email);
      details.append("fcm_token_chr", localStorage.getItem("fcm_token"));
      facebookData?.userID &&
        details.append("social_id_chr", facebookData?.userID);
      details.append("social_account_type_chr", "facebook");
      details.append("role_id_int", parseInt(role));

      details.append("service_request_id_ids", localStorage.getItem("ticket_id") || '');
      details.append("message_opt_in_flag", messageOptInFlag ? 1 : 0);
    }

    if (socialAccType === "apple") {
      details.append(
        "first_name_chr",
        appleData?.firstName ? appleData?.firstName : "Chilll User"
      );
      appleData?.lastName &&
        details.append("last_name_chr", appleData?.lastName);
      appleData?.email && details.append("email_chr", appleData?.email);
      details.append("fcm_token_chr", localStorage.getItem("fcm_token"));
      appleData?.sub && details.append("social_id_chr", appleData?.sub);
      details.append("social_account_type_chr", "apple");
      details.append("role_id_int", parseInt(role));

      details.append("service_request_id_ids", localStorage.getItem("ticket_id") || '');

      localStorage.getItem("referalCode") && details.append("referal_code_chr", localStorage.getItem("referalCode"));
      details.append("message_opt_in_flag", messageOptInFlag ? 1 : 0);
    }

    dispatch(
      registerUserViaThirdPartyApp(
        details,
        (res) => {
          handleAuthenticationWithSocialAcc(res.data);
          setLoaderActive(false);
          setSignInLoader(false);

          dispatch(setIsSignUpFlagTrue());

          localStorage.getItem("referalCode") && localStorage.removeItem("referalCode");
        },
        (err) => {
          setResponceMsg(err.data.message);
          setToasterType("error");
          setLoaderActive(false);
          setSignInLoader(false);

          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);
        }
      )
    );
  };

  const handleSocialSigninError = () => {
    setSignInLoader(false);
    setResponceMsg("Something went wrong, please try after some time.");
    setToasterType("error");

    setHandleToaster(true);
    setTimeout(() => {
      setHandleToaster(false);
    }, 11000);
  };

  const googleSigninCustom = useGoogleLogin({
    // flow: 'auth-code',
    onSuccess: async (tokenResponse) => {
      // console.log(tokenResponse);
      setSignInLoader(true);
      const userInfo = await axios
        .get("https://www.googleapis.com/oauth2/v3/userinfo", {
          headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
        })
        .then((res) => res.data);

      // console.log(userInfo);
      if (userInfo) {
        handleGoogleSignin(userInfo);
      }
    },
    onError: (error) => {
      setSignInLoader(true);
      // console.log("Login Failed:", error);
      handleSocialSigninError();
    },
  });

  // Social Account Singin using the Facebook account
  const handleFacebookSignin = (credentialResponseDecoded) => {
    // console.log(credentialResponseDecoded?.first_name, credentialResponseDecoded?.last_name, credentialResponseDecoded?.email, credentialResponseDecoded?.userID, "Finally Success")
    setSignInLoader(true);
    // console.log(credentialResponseDecoded);
    setFacebookData(credentialResponseDecoded);
    setSocialAccType("facebook");

    let details = new FormData();
    credentialResponseDecoded?.first_name &&
      details.append("first_name_chr", credentialResponseDecoded?.first_name);
    credentialResponseDecoded?.last_name &&
      details.append("last_name_chr", credentialResponseDecoded?.last_name);
    credentialResponseDecoded?.email &&
      details.append("email_chr", credentialResponseDecoded?.email);
    details.append("fcm_token_chr", localStorage.getItem("fcm_token"));
    credentialResponseDecoded?.userID &&
      details.append("social_id_chr", credentialResponseDecoded?.userID);
    details.append("social_account_type_chr", "facebook");

    details.append("service_request_id_ids", localStorage.getItem("ticket_id") || '');

    localStorage.getItem("referalCode") && details.append("referal_code_chr", localStorage.getItem("referalCode"));
    details.append("message_opt_in_flag", messageOptInFlag ? 1 : 0);
    dispatch(
      registerUserViaThirdPartyApp(
        details,
        (res) => {
          setSignInLoader(false);
          handleAuthenticationWithSocialAcc(res.data);

          dispatch(setIsSignUpFlagTrue());

          localStorage.getItem("referalCode") && localStorage.removeItem("referalCode");
        },
        (err) => {
          if (err.data.is_flag_role == 0) {
            // handleShowRoleModal();
            alert('Please select role');
          }
          setSignInLoader(false);

          if (err.data.is_flag_role != 0) {
            setResponceMsg(err.data.message);
            setToasterType("error");

            setHandleToaster(true);
            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);
          }
        }
      )
    );
  };

  const handleAppleSignin = (credentialResponse) => {
    const credentialResponseDecoded = jwtDecode(
      credentialResponse.authorization.id_token
    );
    // console.log(credentialResponseDecoded, "Finally Decoded Apple data comes here")

    setSignInLoader(true);
    setAppleData(credentialResponseDecoded);
    setSocialAccType("apple");

    let details = new FormData();
    details.append(
      "first_name_chr",
      credentialResponseDecoded?.firstName
        ? credentialResponseDecoded?.firstName
        : "Chilll User"
    );
    credentialResponseDecoded?.lastName &&
      details.append("last_name_chr", credentialResponseDecoded?.lastName);
    credentialResponseDecoded?.email &&
      details.append("email_chr", credentialResponseDecoded?.email);
    details.append("fcm_token_chr", localStorage.getItem("fcm_token"));
    credentialResponseDecoded?.sub &&
      details.append("social_id_chr", credentialResponseDecoded?.sub);
    details.append("social_account_type_chr", "apple");
    details.append("role_id_int", parseInt(role));
    localStorage.getItem("companyIdInvite") && details.append("company_id_ids", localStorage.getItem("companyIdInvite"));

    details.append("service_request_id_ids", localStorage.getItem("ticket_id") || '');

    localStorage.getItem("referalCode") && details.append("referal_code_chr", localStorage.getItem("referalCode"));
    details.append("message_opt_in_flag", messageOptInFlag ? 1 : 0);
    dispatch(
      registerUserViaThirdPartyApp(
        details,
        (res) => {
          setSignInLoader(false);
          handleAuthenticationWithSocialAcc(res.data);

          handleClearCompanyInvite()

          dispatch(setIsSignUpFlagTrue());

          localStorage.getItem("referalCode") && localStorage.removeItem("referalCode");
        },
        (err) => {
          if (err.data.is_flag_role == 0) {
            // handleShowRoleModal();
            alert('Please select role');
          }
          setSignInLoader(false);

          if (err.data.is_flag_role != 0) {
            setResponceMsg(err.data.message);
            setToasterType("error");

            setHandleToaster(true);
            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);
          }
        }
      )
    );
  };

  const handleEmailPhone = (e) => {
    // console.log(e.target.value);
    setIsEmailPhoneVal(false);
    noSpaceOnChange(e.target.value) && setEmailPhoneValue(e.target.value);

  };

  const handleDropdownValue = (e) => {
    // setCodeValue(e.target.value);
    setCodeValue(e);

  };

  function handleBlur() {
    if (isPhone) {
      if (emailPhoneValue === "") {
        setIsEmailPhoneVal(true);
        setLoginErrorMsg(errEmptyEmailOrPhone);
      } else if (!phoneValidation(emailPhoneValue)) {
        setIsEmailPhoneVal(true);
        setLoginErrorMsg(validEmail_OR_MobileNumberText);
      }
    } else {
      if (emailPhoneValue === "") {
        setIsEmailPhoneVal(true);
        setLoginErrorMsg(errEmptyEmailOrPhone);
      } else if (!emailValidation(emailPhoneValue)) {
        setIsEmailPhoneVal(true);
        setLoginErrorMsg(validEmail_OR_MobileNumberText);
      }
    }
  }

  function handleFeedbackModal(type, message) {
    setFeedbackMessage(message)
    setFeedbackModal(false);
    // setHandleToaster(true);
    // setTimeout(() => {
    //     setHandleToaster(false);
    // }, 11000);
  }

  return (
    <>
      <div className="" >
        <div className="row  align-items-center justify-contain-center bg-login">
          <div className="col-xl-12 ">
            <div className=" border-0">
              <div className=" login-bx">
                <div className="row custome-row">
                  <div
                    className="col-xl-6 col-md-6  text-center d-flex justify-content-center  align-items-center"
                    style={{ height: '100dvh' }}>
                    <img src={outerMainBannerImg} style={{ width: "100%", height: '100%', objectFit: "cover" }} alt="" />
                  </div>

                  <div
                    // className={`col-xl-6 col-md-6 d-flex justify-content-center align-items-center signUp-right-content-height overflow-auto custome-top-padding pb-3`}
                    className={`col-xl-6 col-md-6`}
                  // style={{
                  //     height: !toggleForSignUpPage ? `100dvh` : ''
                  // }}
                  >
                    <div
                      // className={`d-flex justify-content-center align-items-center signUp-right-content-height overflow-auto custome-top-padding pb-3`}
                      className={`d-flex justify-content-center align-items-center signUp-right-content-height overflow-auto pb-3`}
                      style={{
                        height: !toggleForSignUpPage ? `100dvh` : ''
                      }}
                    >
                      <div
                        className={`sign-in-your pt-3 d-flex justify-content-center align-items-center`}
                        style={{ zoom: '', margin: 'auto' }}
                      >
                        <div className="w-100">

                          <div className="row d-flex justify-content-center mt-2">
                            <img
                              onClick={() => navigate("/signup")}
                              src={logo}
                              style={{ width: "108px", cursor: "pointer" }}
                              alt=""
                            />
                          </div>

                          <div className="row mt-1">
                            <span className="login-subtitle">
                              <h1 className="mb-0" style={{ fontSize: "14px", fontWeight: "400", color: 'grey' }}>{txtANewWay}</h1>
                            </span>
                          </div>





                          {!toggleForSignUpPage ?
                            <div
                              style={{ width: '100%' }}
                            >
                              <div className="row align-items-center justify-content-center p-3 signUp-title">
                                <span>Choose your role</span>
                              </div>

                              <div className="row mb-1">
                                <div
                                  onClick={() => {
                                    setRole("2");
                                    setIsRoleSelected(false);
                                    setToggleForSignUpPage(true)
                                  }}
                                  className={`signUp-role-select rounded-2 shadow-lg px-3 bg-white border-hovered`}
                                  style={{
                                    cursor: "pointer",
                                    // background: role === "2" ? "#ffa50029" : "white",
                                    border:
                                      role === "2"
                                        ? "1px solid #fc8019"
                                        : "1px solid lightgrey",
                                  }}
                                >
                                  <div className="pe-3">
                                    <input
                                      className="form-check-input"
                                      style={{ display: 'inline-block' }}
                                      name="selectRole"
                                      type="radio"
                                      value={`2`}
                                      onChange={(e) => { setRole("2") }}
                                      checked={role == "2"}
                                    />
                                  </div>

                                  <div className="position-relative" style={{ width: '75px' }}>
                                    <img
                                      className="position-absolute"
                                      style={{ width: '65px', bottom: '-40px' }}
                                      src={customerImg}
                                      alt=""
                                    />
                                  </div>

                                  <div className="d-flex flex-column">
                                    <span
                                      style={{
                                        fontWeight: "600",
                                        fontSize: "14px",
                                        color: "black",
                                      }}>
                                      {txtRoleCustomerTitle}
                                    </span>
                                    <span style={{ fontSize: "12px" }}>
                                      {txtRoleCustomerSubTitle}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div className="row mb-2">
                                <div
                                  onClick={() => {
                                    setRole("1");
                                    setIsRoleSelected(false);
                                    setToggleForSignUpPage(true)
                                  }}
                                  className={`signUp-role-select rounded-2 shadow-lg px-3 bg-white border-hovered`}
                                  style={{
                                    cursor: "pointer",
                                    border:
                                      role === "1"
                                        ? "1px solid #fc8019"
                                        : "1px solid lightgrey",
                                  }}>

                                  <div className="pe-3">
                                    <input
                                      className="form-check-input"
                                      style={{ display: 'inline-block' }}
                                      name="selectRole"
                                      type="radio"
                                      value={`1`}
                                      onChange={(e) => {
                                        setRole("1")

                                      }}
                                      checked={role == "1"}
                                    />
                                  </div>


                                  <div className="position-relative" style={{ width: '75px' }}>
                                    <img
                                      className="position-absolute"
                                      style={{ width: '65px', bottom: '-40px' }}
                                      src={proImg}
                                      alt=""
                                    />
                                  </div>

                                  <div className="d-flex flex-column">
                                    <span
                                      style={{
                                        fontWeight: "600",
                                        fontSize: "14px",
                                        color: "black",
                                      }}>
                                      {txtRoleProTitle}
                                    </span>
                                    <span style={{ fontSize: "12px" }}>
                                      {txtRoleProSubTitle}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              {isRoleSelected && (
                                <div className="row">
                                  <p style={{ color: "red", marginBottom: "0px" }}>
                                    {"Please select your role"}
                                  </p>
                                </div>
                              )}
                              {/* 
                          <div
                            className="row mt-3"
                            style={{
                              pointerEvents: role ? 'auto' : 'none',
                              opacity: role ? '1' : '0.5',
                            }}
                          >
                            <PrimaryButton
                              buttonName={"CONTINUE"}
                              style={{
                                width: "100%",
                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                border: '2px solid rgba(255, 154, 32, 1)',
                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                              }}
                              isLoading={loaderActive}
                              loadingMessage={"Starting..."}
                              iconClassName={"bi bi-arrow-right"}
                              needIcon={true}
                              onClick={() => handleRoleSelected()}
                            />
                          </div> */}
                            </div>
                            :
                            <div className="row">
                              <div className="row flex-column">
                                <span className="login-title text-black mb-3" >
                                  {/* {`${lblSignUpTitle} ${role == 1 ? 'Pro' : role == 2 ? 'Customer' : ''}`} */}
                                  {`${role == 1 ? 'Pro' : role == 2 ? 'Customer' : ''} Sign-Up`}
                                </span>

                                {/* <span className="font-w600 fs-5 mb-3 text-center text-success">{`Get $100 free credits.`}</span> */}

                              </div>

                              {/* {!localStorage.getItem("roleCompanyInvite") &&
                                                          <div className="row mx-0 my-3">
                                                              <div className="col-12 fs-5 font-w500 d-flex align-items-center">
                                                                  {role == 1 ?
                                                                      <>
                                                                          <span className="pe-4 text-black ">{`Need things fixed? `}</span>
                                                                          <span
                                                                              className="cursor-pointer text-hovered text-success font-w600"
                                                                              onClick={() => { setRole(2) }}
                                                                          >
                                                                              {`Join as Customer`}
                                                                          </span>
                                                                      </> :
                                                                      role == 2 ? <>
                                                                          <span className="pe-4 text-black ">{`Looking for work? `}</span>
                                                                          <span
                                                                              className="cursor-pointer text-hovered text-success font-w600"
                                                                              onClick={() => { setRole(1) }}
                                                                          >
                                                                              {`Apply as Pro`}
                                                                          </span>
                                                                      </> : null

                                                                  }
                                                              </div>
                                                          </div>
                                                      } */}

                              <form onSubmit={handleSignUp} autoComplete={false}>
                                <div className="row d-flex justify-content-between mt-2 ">
                                  <div className="col-6 pe-2">
                                    <InputField
                                      labelName={lblFirstName}
                                      placeholderName={lblFirstName}
                                      value={firstName}
                                      onChange={handleFirstName}
                                      errorOccured={isFirstNameError}
                                      errorMeesage={errorFirstNameMsg}
                                      onBlur={handleFirstNameBlurCheck}
                                      isRequired={true}
                                      autoF={true}
                                    />
                                  </div>

                                  <div className="col-6 ps-2">
                                    <InputField
                                      labelName={lblLastName}
                                      placeholderName={lblLastName}
                                      value={lastName}
                                      onChange={handleLastName}
                                      errorOccured={false}
                                      errorMeesage={""}
                                      onBlur={() => { }}
                                    />
                                  </div>
                                </div>

                                {/* <div className="row" style={{ marginBottom: "-5px" }}>
                                  <InputField
                                    labelName={role == 1 ? "Doing business as" : "Preferred name"}
                                    value={alias}
                                    onChange={(e) => { handleAlias(e) }}
                                    errorOccured={false}
                                    errorMeesage={""}
                                    onBlur={() => { }}
                                  />
                                </div> */}

                                <div className="row mb-3">
                                  <EmailPhoneCombine
                                    isEnteringNumber={isPhone}
                                    setIsEnteringNumber={setIsPhone}
                                    handleInputValue={handleEmailPhone}
                                    handleChangeCode={handleDropdownValue}
                                    errorOccured={isEmailPhoneVal}
                                    inputValue={emailPhoneValue}
                                    handleOnBlur={handleBlur}
                                    defaultCodeValue={codeValue}
                                    errorMessage={
                                      // validEmail_OR_MobileNumberText
                                      loginErrorMsg
                                    }
                                    isRequired={true}
                                  />
                                </div>

                                {/* <div className="row">
                              <InputField
                                labelName={lblEmail}
                                placeholderName={"Enter email"}
                                onChange={handleEmail}
                                errorMeesage={validEmailText}
                                errorOccured={isEmailError}
                                onBlur={handleEmailBlurCheck}
                                value={email}
                              />
                            </div>

                            <div className="row">
                              <EmailPhoneCombine
                                inputValue={phonenumber}
                                handleInputValue={handlePhonenumber}
                                errorOccured={isPhoneError}
                                errorMessage={validMobileNumberText}
                                handleChangeCode={handleCountryCode}
                                handleOnBlur={() => { handlePhonenumberBlurCheck() }}
                                isEnteringNumber={true}
                                defaultCodeValue={countryCode}
                                label={txtMobileNumber}
                              />
                            </div> */}




                                {/* <div className="row mb-2">
                                  <InputField
                                    labelName={"Zip code"}
                                    value={zipCode}
                                    onChange={(e) => { handleZipCode(e) }}
                                    errorOccured={false}
                                    errorMeesage={""}
                                    onBlur={() => { }}
                                  />
                                </div> */}

                                <div className="row" style={{ marginBottom: "-10px" }}>
                                  <PasswordField
                                    labelName={lblPassword}
                                    showRequirements
                                    onChange={handlePassword}
                                    inputValue={password}
                                    errorOccured={isPassword}
                                    errorMessage={password ? "Select Password to see the requirements." : passwordErrorMsg}
                                    handleOnBlur={() => { handleBlurPassword() }}
                                    onFocus={() => setIsFocused(true)}
                                  />
                                </div>

                                <div className='row mx-0 mb-3'>
                                  <div className='row'>
                                    <div className='col-12 px-0' >
                                      <div className="d-flex">
                                        <span>
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="refund"
                                            name="refund"
                                            onChange={(e) => {
                                              setMessageOptInFlag(!messageOptInFlag);
                                            }}
                                            value={messageOptInFlag}
                                            checked={messageOptInFlag}
                                          />
                                        </span>

                                        <span
                                          className='ps-3  text-black fs-5'
                                        >
                                          {`I agree to receive SMS messages from Chilll regarding OTP verification, password reset, service request notifications, and account notifications. Message frequency varies. Message and data rates may apply. Text HELP for help. Text STOP to cancel. (Optional)`}
                                          {/* <strong className='text-hovered cursor-pointer ps-1' >
                                            <a
                                              className="terms-condition-link"
                                              href="https://chilll.com/chilll-terms-conditions/"
                                              target="_blank"
                                              rel="noreferrer">
                                              {"Terms and Conditions "}
                                            </a>
                                          </strong> */}
                                        </span>
                                      </div>
                                      {/* {termsAndConditionsErr &&
                                        <div className='mt-2 text-danger fs-12'>
                                          <span>{`Please accept the Terms & Conditions`}</span>
                                        </div>
                                      } */}
                                    </div>
                                  </div>
                                </div>

                                <div className='row mx-0 mb-3'>
                                  <div className='row'>
                                    <div className='col-12 px-0' >
                                      <div className="d-flex">
                                        <span>
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="refund"
                                            name="refund"
                                            onChange={(e) => {
                                              setTermsAndConditions(!termsAndConditions);
                                              setTermsAndConditionsErr(false)
                                            }}
                                            value={termsAndConditions}
                                            checked={termsAndConditions}
                                          />
                                        </span>

                                        <span
                                          className='ps-3  text-black fs-5'
                                        >
                                          {`*I agree to the`}
                                          <strong className='text-hovered cursor-pointer ps-1' >
                                            <a
                                              className="terms-condition-link"
                                              href="https://chilll.com/chilll-terms-conditions/"
                                              target="_blank"
                                              rel="noreferrer">
                                              {"Terms and Conditions"}
                                            </a>
                                          </strong> {`|`}
                                          <strong className='text-hovered cursor-pointer ps-1' >
                                            <a
                                              className="terms-condition-link"
                                              href="https://chilll.com/privacy-policy/"
                                              target="_blank"
                                              rel="noreferrer">
                                              {"Privacy Policy"}
                                            </a>
                                          </strong>
                                        </span>
                                      </div>
                                      {termsAndConditionsErr &&
                                        <div className='mt-2 text-danger fs-12'>
                                          <span>{`Please accept the Terms & Privacy Policy`}</span>
                                        </div>
                                      }
                                    </div>
                                  </div>
                                </div>

                                {/* <div className="row mx-0">
                              <div className="col-12 px-0">
                                {(isFocused || isPassword) &&
                                  <PasswordChecker password={password} />
                                }
                              </div>
                            </div> */}

                                {/* <div className="row">
                                                              <PasswordField
                                                                  onChange={handlePasswordConfirm}
                                                                  inputValue={passwordConfirm}
                                                                  errorOccured={isPasswordConfirm}
                                                                  errorMessage={"Password doesnot match"}
                                                                  labelName={"Confirm password"}
                                                                  handleOnBlur={handleBlurPasswordConfirm}
                                                              />
                                                          </div> */}

                                <PrimaryButton
                                  buttonName={btnSignUp}
                                  type={"submit"}
                                  onClick={handleSignUp}
                                  isLoading={loaderActive}
                                  loadingMessage={"Loading..."}
                                  style={{
                                    width: "100%",
                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                    border: '2px solid rgba(255, 154, 32, 1)',
                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                  }}
                                />
                              </form>
                            </div>
                          }











                          {toggleForSignUpPage && <>

                            <div className="separator-custom my-3">
                              <div
                                className="line-custom me-3"></div>
                              <span className="text-custom fs-6">{lblOr}</span>
                              <div
                                className="line-custom ms-3"></div>
                            </div>



                            <div className="row d-flex justify-content-center " style={{ pointerEvents: signInLoader ? 'none' : 'auto', opacity: signInLoader ? 0.5 : 1 }}>

                              {/* Google Signin custom Button for login */}
                              <div className="col-6 d-flex justify-content-center">
                                <div className="buttoncover">
                                  <Button
                                    className="signin-custom-btn mb-1"
                                    onClick={() => googleSigninCustom()}>
                                    <img
                                      src={googleIcon}
                                      alt=""
                                      style={{ maxWidth: "30px" }}
                                    />
                                    <span>{" GOOGLE"}</span>
                                    <span></span>
                                  </Button>
                                </div>
                              </div>

                              {/* Apple Signin custom Button for login */}
                              <div className="col-6 d-flex justify-content-center">
                                <div className="buttoncover">
                                  <LoginSocialApple
                                    client_id={process.env.REACT_APP_APPLE_ID || ""}
                                    scope={"name email"}
                                    redirect_uri={
                                      process.env.REACT_APP_REDIRECT_URL_FOR_APPLE
                                    }
                                    // onLoginStart={onLoginStart}
                                    onResolve={(response) => {
                                      // console.log(response);
                                      handleAppleSignin(response.data);
                                    }}
                                    onReject={(err) => {
                                      // console.log(err);
                                      // handleSocialSigninError();
                                    }}>
                                    {/* <AppleLoginButton className="signin-custom-btn" /> */}
                                    <Button className="signin-custom-btn ">
                                      <img
                                        src={appleIcon}
                                        alt=""
                                        style={{ maxWidth: "30px" }}
                                      />
                                      <span>{" APPLE"}</span>
                                      <span></span>
                                    </Button>
                                  </LoginSocialApple>
                                </div>
                              </div>
                            </div>
                          </>}


                          {/* {<div className="separator-custom my-3">
                            <div
                              className="line-custom me-3"></div>
                            <span className="text-custom fs-6">{btnAlreadyAUser}</span>
                            <div
                              className="line-custom ms-3"></div>
                          </div>} */}


                          {/* <div className="">
                            {<PrimaryButton
                              buttonName={btnLogin}
                              className={"mb-3"}
                              loadingMessage={"Loading..."}
                              style={{
                                width: "100%",
                                background: '#fff',
                                border: '1px solid rgb(199, 212, 234) ',
                                boxShadow: '0px 6px 12px 0px rgba(102, 129, 172, 0.12)',
                                color: "black",
                                fontWeight: 600
                              }}
                              onClick={() => {
                                navigate("/login");
                                handleClearCompanyInvite();
                              }}
                            />}
                          </div> */}

                          <div className="row mt-3">
                            <div
                              className="col-12 d-flex justify-content-center align-items-center text-center"
                              style={{ fontSize: '14px' }}
                            >
                              <span className="me-1">{`Already have an account?`}</span>
                              <span className="terms-condition-link text-center text-primary"
                                onClick={() => {
                                  navigate("/login");
                                }}
                              >
                                {`Login`}
                              </span>
                            </div>
                          </div>

                          <div className="row mt-3">
                            <span className="terms-condition-link text-center"
                              onClick={() => {
                                setFeedbackModal(true);
                              }}
                            >
                              {`Give us feedback`}
                            </span>
                          </div>

                          {toggleForSignUpPage && <div className="row mt-3">
                            <div style={{ textAlign: "center", color: 'black', fontWeight: 600 }}>
                              By continuing, you agree to Chilll<br></br>
                              <div className="">
                                <a
                                  className="terms-condition-link"
                                  href="https://chilll.com/chilll-terms-conditions/"
                                  target="_blank"
                                  rel="noreferrer">
                                  {"Terms and Conditions"}
                                </a>
                                <span style={{ color: 'black', fontWeight: 600 }}>{` and `}</span>
                                <a
                                  className="terms-condition-link"
                                  href="https://chilll.com/privacy-policy/"
                                  target="_blank"
                                  rel="noreferrer">
                                  {"Privacy Policy"}
                                </a>
                              </div>
                            </div>
                          </div>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {feedbackModal && (
        <FeedbackModal
          addUserTrigger={feedbackModal}
          handleCloseAddUser={handleFeedbackModal}
        />
      )}

      {handleToaster && (
        <ResponceToaster toasterType={toasterType} message={responceMsg} />
      )}
    </>
  );
}


